module.exports = __webpack_public_path__ + "img/notification.02079892.svg";